module.exports = __webpack_public_path__ + "media/categories/4008-ce2698d5.svg";